// 絞り込み
document.addEventListener("DOMContentLoaded", () => {
	const filterButtons = document.querySelectorAll(".campaign__side-button");
	const items = [...document.querySelectorAll(".campaign__item")];
	const container = document.querySelector(".campaign__list");

	// 元のデータを保存しておく
	const allItems = items.map((item) => item.cloneNode(true));

	const initialFilter = "all";
	filterButtons.forEach((btn) => {
		const isAll = btn.getAttribute("data-filter") === initialFilter;
		btn.setAttribute("aria-pressed", isAll ? "true" : "false");
	});

	// 初期表示
	renderItems(initialFilter);

	filterButtons.forEach((button) => {
		button.addEventListener("click", () => {
			const filter = button.getAttribute("data-filter");

			filterButtons.forEach((btn) => btn.setAttribute("aria-pressed", "false"));
			button.setAttribute("aria-pressed", "true");

			renderItems(filter);
		});
	});

	function renderItems(filter) {
		container.innerHTML = "";
		allItems.forEach((item) => {
			const categoryEl = item.querySelector(".campaign__cat");
			const category = categoryEl ? categoryEl.getAttribute("data-category") : "";

			if (filter === "all" || category === filter) {
				container.appendChild(item.cloneNode(true));
			}
		});
	}
});
